import { render } from "./dropdown-btn.vue?vue&type=template&id=3e63fd66"
import script from "./dropdown-btn.vue?vue&type=script&lang=js"
export * from "./dropdown-btn.vue?vue&type=script&lang=js"

import "./dropdown-btn.vue?vue&type=style&index=0&id=3e63fd66&lang=less"

import exportComponent from "F:\\code\\flash-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__